import { ReactElement } from "react";
import { Trans, TransProps } from "react-i18next";

export const TransElement = Trans as (
  props: TransProps<string>,
) => ReactElement;

export enum DATA_ATTRIBUTES {
  READY_BLOCK_ID = "data-ready-block-id",
  TEMPLATE_ID = "data-template-id",
}

export enum NAVIGATION_ICON_DEFAULT {
  SLIDER_ICONS_SIZE = 35,
  SLIDER_ICONS_COLOR = "rgb(255, 255, 255)",
  SLIDER_INDICATOR_SIZE_DOT = 16,
  SLIDER_INDICATOR_SIZE_SQUARE = 30,
  SLIDER_INDICATOR_COLOR = "rgb(255, 255, 255)",
  ACCORDION_ICON_SIZE = 20,
  ACCORDION_ICON_COLOR = "rgb(0, 0, 0)",
}

export enum HEADER_STYLE_DEFAULT {
  PADDING_Y = "21.5px",
  PADDING_X = "72px",
  PADDING_MOBILE_Y = "16px",
  PADDING_MOBILE_X = "12px",
  BACKGROUND = "#ffff",
}

export const DESKTOP_CONFIG = {
  headerPaddingX: HEADER_STYLE_DEFAULT.PADDING_X,
  headerPaddingY: HEADER_STYLE_DEFAULT.PADDING_Y,
  logoSize: "46px",
  logoMargin: "24px",
  companyText: "font-size: 24px; color: #3E4957",
  subtext: "font-size: 16px; color: #8B929A",
  isMobileSupportNeeded: true,
};

export const MOBILE_PAGE_CONFIG = {
  headerPaddingX: HEADER_STYLE_DEFAULT.PADDING_MOBILE_X,
  headerPaddingY: HEADER_STYLE_DEFAULT.PADDING_MOBILE_Y,
  logoSize: "24px",
  logoMargin: "8px",
  companyText: "font-size: 20px; color: #3E4957",
  subtext: "display: none",
  isMobileSupportNeeded: false,
};

export const HEADER_BUTOON_DESKTOP_CONFIG = {
  width: "141px",
  height: "40px",
  paddingTop: "6px",
  paddingBottom: "6px",
  paddingLeft: "24px",
  paddingRight: "24px",
  marginLeft: "0px",
};

export const HEADER_BUTTON_MOBILE_CONFIG = {
  width: "62px",
  height: "32px",
  paddingTop: "2px",
  paddingBottom: "2px",
  paddingLeft: "6px",
  paddingRight: "6px",
  marginLeft: "8px",
};

export enum MENU_ICON_SET_STYLE {
  LIGHT = "light",
  MEDIUM = "medium",
  BOLD = "bold",
}

export const IconPresets = {
  [MENU_ICON_SET_STYLE.LIGHT]: {
    menu: `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.875 14.375C16.875 14.0298 16.5952 13.75 16.25 13.75H3.75C3.40482 13.75 3.125 14.0298 3.125 14.375C3.125 14.7202 3.40482 15 3.75 15H16.25C16.5952 15 16.875 14.7202 16.875 14.375Z" fill="#3E4957"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.875 9.375C16.875 9.02982 16.5952 8.75 16.25 8.75H3.75C3.40482 8.75 3.125 9.02982 3.125 9.375C3.125 9.72018 3.40482 10 3.75 10H16.25C16.5952 10 16.875 9.72018 16.875 9.375Z" fill="#3E4957"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.875 4.375C16.875 4.02982 16.5952 3.75 16.25 3.75H3.75C3.40482 3.75 3.125 4.02982 3.125 4.375C3.125 4.72018 3.40482 5 3.75 5H16.25C16.5952 5 16.875 4.72018 16.875 4.375Z" fill="#3E4957"/>
      </svg>
    `,
    close: `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.3169 3.56694C17.561 3.32286 17.561 2.92714 17.3169 2.68306C17.0729 2.43898 16.6771 2.43898 16.4331 2.68306L10 9.11612L3.56694 2.68306C3.32286 2.43898 2.92713 2.43898 2.68306 2.68306C2.43898 2.92714 2.43898 3.32286 2.68306 3.56694L9.11612 10L2.68306 16.4331C2.43898 16.6771 2.43898 17.0729 2.68306 17.3169C2.92714 17.561 3.32286 17.561 3.56694 17.3169L10 10.8839L16.4331 17.3169C16.6771 17.561 17.0729 17.561 17.3169 17.3169C17.561 17.0729 17.561 16.6771 17.3169 16.4331L10.8839 10L17.3169 3.56694Z" fill="#3E4957"/>
      </svg>
    `,
  },
  [MENU_ICON_SET_STYLE.MEDIUM]: {
    menu: `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 15.625C2.5 15.2798 2.77982 15 3.125 15H16.875C17.2202 15 17.5 15.2798 17.5 15.625C17.5 15.9702 17.2202 16.25 16.875 16.25H3.125C2.77982 16.25 2.5 15.9702 2.5 15.625Z" fill="#3E4957"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 11.875C2.5 11.5298 2.77982 11.25 3.125 11.25H16.875C17.2202 11.25 17.5 11.5298 17.5 11.875C17.5 12.2202 17.2202 12.5 16.875 12.5H3.125C2.77982 12.5 2.5 12.2202 2.5 11.875Z" fill="#3E4957"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 8.125C2.5 7.77982 2.77982 7.5 3.125 7.5H16.875C17.2202 7.5 17.5 7.77982 17.5 8.125C17.5 8.47018 17.2202 8.75 16.875 8.75H3.125C2.77982 8.75 2.5 8.47018 2.5 8.125Z" fill="#3E4957"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 4.375C2.5 4.02982 2.77982 3.75 3.125 3.75H16.875C17.2202 3.75 17.5 4.02982 17.5 4.375C17.5 4.72018 17.2202 5 16.875 5H3.125C2.77982 5 2.5 4.72018 2.5 4.375Z" fill="#3E4957"/>
      </svg>
    `,
    close: `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.1045 9.02083L5.72949 4.64583C5.60449 4.52083 5.45866 4.45833 5.29199 4.45833C5.12533 4.45833 4.97949 4.52083 4.85449 4.64583C4.72949 4.77083 4.66699 4.91666 4.66699 5.08333C4.66699 5.25 4.72949 5.39583 4.85449 5.52083L9.22949 9.89583L4.85449 14.2708C4.72949 14.3958 4.66699 14.5417 4.66699 14.7083C4.66699 14.875 4.72949 15.0208 4.85449 15.1458C4.97949 15.2708 5.12533 15.3333 5.29199 15.3333C5.45866 15.3333 5.60449 15.2708 5.72949 15.1458L10.1045 10.7708L14.4795 15.1458C14.6045 15.2708 14.7503 15.3333 14.917 15.3333C15.0837 15.3333 15.2295 15.2708 15.3545 15.1458C15.4795 15.0208 15.542 14.875 15.542 14.7083C15.542 14.5417 15.4795 14.3958 15.3545 14.2708L10.9795 9.89583L15.3545 5.52083C15.4795 5.39583 15.542 5.25 15.542 5.08333C15.542 4.91666 15.4795 4.77083 15.3545 4.64583C15.2295 4.52083 15.0837 4.45833 14.917 4.45833C14.7503 4.45833 14.6045 4.52083 14.4795 4.64583L10.1045 9.02083Z" fill="#3E4957"/>
      </svg>
    `,
  },
  [MENU_ICON_SET_STYLE.BOLD]: {
    menu: `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.83301 15.375V13.1667H18.1663V15.375H1.83301ZM1.83301 11.0833V8.87499H18.1663V11.0833H1.83301ZM1.83301 6.79166V4.58333H18.1663V6.79166H1.83301Z" fill="#3E4957"/>
      </svg>
    `,
    close: `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.24967 16.3333L3.70801 14.75L8.43717 10L3.70801 5.20833L5.24967 3.625L10.0205 8.41667L14.7497 3.625L16.2913 5.20833L11.5622 10L16.2913 14.75L14.7497 16.3333L10.0205 11.5417L5.24967 16.3333Z" fill="#3E4957"/>
      </svg>
    `,
  },
};

export enum DOM_NODE_TYPE {
  ELEMENT = 1,
  TEXT = 3,
}

export enum PAGE_TYPE {
  DESKTOP = 1,
  MOBILE = 2,
  BOTH = 3,
}

export enum ERRORS {
  UNIQUE_URL = "The page URL must be unique for the project",
  SUBPAGES_LIMIT = "You have reached the limit of 20 subpages for this page.",
  INVALUD_URL = "The URL should only contain letters, numbers, hyphens and underscores.",
}

export const ALLOWED_FILES = {
  IMAGE: [".jpg", ".jpeg", ".png", ".svg", ".webp", ".heic"],
  PRELOADER: [".jpg", ".jpeg", ".png"],
  FILE: [
    ".jpg",
    ".jpeg",
    ".png",
    ".svg",
    ".webp",
    ".docx",
    ".mp4",
    ".pdf",
    ".heic",
  ],
  ANIMATED: [".gif"],
} as const;

export const ALL_ALLOWED_FILES = Array.from(
  new Set(Object.values(ALLOWED_FILES).flat()),
);

export const imagePlug =
  "https://cdn.me-qr.com/n1ed/files/-1786156666/Frame%2040004%20(9).png";

export const SOCIAL_NETWORKS = [
  "Instagram",
  "Facebook",
  "YouTube",
  "TikTok",
  "X (Twitter)",
  "Threads",
  "WhatsApp",
  "Telegram",
  "Viber",
  "Messenger",
  "WeChat",
  "Signal",
  "Discord",
  "Slack",
  "Spotify",
  "Pinterest",
  "LinkedIn",
  "Reddit",
  "SnapChat",
  "GitHub",
  "Twitch",
  "Steam",
  "Behance",
  "Medium",
];

export const LANGUAGES = [
  {
    locale: "AR",
    name: "العربية",
  },
  {
    locale: "DE",
    name: "Deutsch",
  },
  {
    locale: "EN",
    name: "English",
  },
  {
    locale: "ES",
    name: "Español",
  },
  {
    locale: "FR",
    name: "Français",
  },
  {
    locale: "HE",
    name: "עברית",
  },
  {
    locale: "HI",
    name: "हिन्दी",
  },
  {
    locale: "ID",
    name: "Bahasa Indonesia",
  },
  {
    locale: "IT",
    name: "Italiano",
  },
  {
    locale: "JA",
    name: "日本語",
  },
  {
    locale: "KO",
    name: "한국어",
  },
  {
    locale: "MS",
    name: "Bahasa Melayu",
  },
  {
    locale: "NL",
    name: "Nederlands",
  },
  {
    locale: "PT",
    name: "Português",
  },
  {
    locale: "RU",
    name: "Русский",
  },
  {
    locale: "SV",
    name: "Svenska",
  },
  {
    locale: "TH",
    name: "ไทย",
  },
  {
    locale: "UK",
    name: "Українська",
  },
  {
    locale: "vi",
    name: "Tiếng Việt",
  },
  {
    locale: "ZH",
    name: "中文",
  },
];

export const LOCALES = LANGUAGES.map(({ locale }) => locale.toLowerCase());

export const ME_PROJECT_DOMAINS = [
  "me-page.com",
  "me-page.org",
  "me-qr.com",
  "me-qr.de",
  "me-ticket.com",
  "me-team.org",
  "me-pos.com",
  "me-promo.com",
  "me-recommend.com",
  "me-ads.org",
  "me-cluster.com",
  "me-short-link.com"
];
